import { IUserSession } from '../../../helpers/user-session'

import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { $Q_SERVICE_NAME, $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'

import { DepositoryHelper } from '../depositories.helper'

import { DepositoryCreateEditController } from './depositories-create-edit.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './depositories-create-edit.tpl.html'

//#endregion

// Setup

export class DepositoryCreateEditDirective implements ng.IDirective {
    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            userSession: IUserSession
        ) => new DepositoryCreateEditController(
            $scope,
            $q,
            $timeout,
            userSession,
            DepositoryHelper.SIMAX_MODULE_NAME
        )]

    template = TEMPLATE
}

// Setup End